

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M10.75 0C16.68 0 21.5 4.82 21.5 10.75S16.68 21.5 10.75 21.5 0 16.68 0 10.75 4.82 0 10.75 0Zm0 1.5c-5.1 0-9.25 4.15-9.25 9.25S5.65 20 10.75 20 20 15.85 20 10.75 15.85 1.5 10.75 1.5Zm-.73 5.19 3.53 3.53c.29.29.29.77 0 1.06l-3.53 3.53c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l3-3-3-3a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0Z"}, []), "\n"]);
};

        